import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CalculatorResult } from '../../../../models/analysis/solar-calculator-result';
import { inOutAnimation } from '../../../../animations';
import { CalculatorResultWrapper } from '../../../../models/analysis/calculator-result-wrapper';
import { PowerPlant } from '../../model/power-plant';
import { YearlySpendingResult } from "../../value-components/yearly-spendings/yearly-spending.component";
import { PriceCountry } from '../../../../models/price/price';

@Component({
  selector: 'psc-hourly-manual-result',
  templateUrl: './hourly-manual-result.component.html',
  animations: [inOutAnimation({})],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HourlyManualResultComponent {
  @Input() calculatorResultWrapper: CalculatorResultWrapper;
  @Input() powerPlant: PowerPlant;

  get hourlySolarCalculatorResult(): CalculatorResult {
    return this.calculatorResultWrapper.result;
  }
  get yearlySpending(): YearlySpendingResult[] {
    return this.calculatorResultWrapper?.result?.yearlySpending || [];
  }

  protected readonly PriceCountry = PriceCountry;
}
